exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/core-js@2.6.12/~/core-js/library/modules/_object-gops.js
// module id = 292
// module chunks = 0